var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 5.56767C14.875 5.26308 14.8353 4.96629 14.761 4.68508C14.6958 4.43787 14.3912 4.37908 14.2113 4.55971L12.9908 5.78016C12.8746 5.89644 12.7365 5.98867 12.5846 6.0516C12.4327 6.11453 12.2699 6.14692 12.1054 6.14692C11.941 6.14692 11.7782 6.11453 11.6262 6.0516C11.4743 5.98867 11.3363 5.89644 11.22 5.78016C11.1037 5.66389 11.0115 5.52585 10.9486 5.37393C10.8856 5.22201 10.8532 5.05919 10.8532 4.89475C10.8532 4.73031 10.8856 4.56748 10.9486 4.41556C11.0115 4.26364 11.1037 4.12561 11.22 4.00933L12.4405 2.78958C12.6211 2.60896 12.5623 2.30437 12.3151 2.23921C11.709 2.078 11.0704 2.08542 10.4683 2.26066C9.86614 2.43589 9.32329 2.77228 8.89837 3.23352C8.47345 3.69475 8.18259 4.2633 8.05721 4.87777C7.93182 5.49224 7.97667 6.12928 8.18692 6.72012C8.23721 6.86179 8.20887 7.02046 8.10333 7.126L2.3375 12.8918C2.05417 13.1752 2.05417 13.6349 2.3375 13.9175L3.08267 14.6627C3.366 14.946 3.82429 14.946 4.10762 14.6627L9.87346 8.89683C9.97971 8.79058 10.1384 8.76225 10.2793 8.81254C10.7988 8.99723 11.3551 9.05444 11.9013 8.97936C12.4475 8.90428 12.9677 8.6991 13.4181 8.38109C13.8685 8.06308 14.2359 7.64154 14.4894 7.15194C14.743 6.66234 14.8752 6.11901 14.875 5.56767Z",
    stroke: "url(#paint0_linear_250_860)",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_860",
    x1: 8.5,
    y1: 2.12354,
    x2: 8.5,
    y2: 14.8752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3612C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A095D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanner);
export default __webpack_public_path__ + "static/media/Spanner.af5a9d07171ce9a2356fbe378257324a.svg";
export { ForwardRef as ReactComponent };